<p>socios-form-dialog works!</p>
